import { menuList } from './menuCombo';

export class menuListClone {
    menuListClone = menuList;
}
